import { create } from 'zustand'
import { Invoice, InvoiceDetail } from '@/types/facturation.types'
import { facturationService } from '@/services/facturation.service'

interface FacturationState {
  invoices: Invoice[] | null
  selectedInvoice: InvoiceDetail | null
  isInitialized: boolean
  isDetailLoading: boolean
  fetchInvoices: () => Promise<void>
  fetchInvoiceById: (id: string) => Promise<InvoiceDetail>
  clearSelectedInvoice: () => void
}

export const useFacturationStore = create<FacturationState>((set, get) => ({
  invoices: null,
  selectedInvoice: null,
  isInitialized: false,
  isDetailLoading: false,

  fetchInvoices: async () => {
    if (get().isInitialized) {
      return
    }

    try {
      const data = await facturationService.getAll()
      set({ invoices: data, isInitialized: true })
    } catch (error) {
      console.error('Error loading invoices:', error)
      throw error
    }
  },

  fetchInvoiceById: async (id: string) => {
    set({ isDetailLoading: true })
    try {
      const detail = await facturationService.getById(id)
      set({ selectedInvoice: detail })
      return detail
    } catch (error) {
      console.error('Error loading invoice detail:', error)
      throw error
    } finally {
      set({ isDetailLoading: false })
    }
  },

  clearSelectedInvoice: () => {
    set({ selectedInvoice: null })
  },
}))
